import { render } from "./App.vue?vue&type=template&id=3756c638&scoped=true"
import script from "./App.js?vue&type=script&lang=js&external"
export * from "./App.js?vue&type=script&lang=js&external"

import "./App.vue?vue&type=style&index=0&id=3756c638&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3756c638"]])

export default __exports__